import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {SUCCESS} from "../../httpClient";
import {fetchNotifications, markNotificationAsRead, markNotificationAsUnRead} from "./notificationAPI";

const initialState = {
    notifications: [],
    status: 'idle',
}

const notifications = "notifications";

export const fetchNotificationsAsync = createAsyncThunk(
    `${notifications}/fetchNotifications`,
    async (token) => {
        return await fetchNotifications(token);
    }
);

export const markNotificationAsReadAsync = createAsyncThunk(
    `${notifications}/readNotification`,
    async (token, notificationId) => {
        return await markNotificationAsRead(token, notificationId)
    }
);

export const markNotificationAsUnreadAsync = createAsyncThunk(
    `${notifications}/readNotification`,
    async (token, notificationId) => {
        return await markNotificationAsUnRead(token, notificationId)
    }
);

export const notificationSlice = createSlice({
    name: `${notifications}`,
    initialState,
    reducers: {
        loadNotifications: (state,action) => {
            state.notifications = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotificationsAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchNotificationsAsync.fulfilled, (state, action) => {
                state.status = SUCCESS;
                state.notifications = action.payload
            })
    }
});

export default notificationSlice.reducer;
